export default __webpack_public_path__ + "static/media/noRaceImage.192b47a5.png";